import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import type { APIResponse, CogsBasisState } from '@/types'

/** F-RPT-N41. The cache holds the envelope; consumers read the selected state. */
export function useCogsBasis(enabled = true) {
  return useQuery({
    queryKey: ['cogsBasis'] as const,
    queryFn: () => apiClient.getCogsBasis(),
    enabled,
    staleTime: 60_000,
    select: (res: APIResponse<CogsBasisState>) => res.data,
  })
}
